module.exports = __webpack_public_path__ + "media/images/onboarding_manager_done-668f6ceb68dc75d325676693f2f6ba49.png";